import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-password2",
  "use": "icon-password2-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-password2\"><defs><style></style></defs><path d=\"M561.102 442.686c-34.95-95.16-129.199-163.354-240.046-163.354-140.56 0-254.542 109.692-254.542 245.014s113.982 245.013 254.542 245.013c126.137 0 230.78-88.306 250.992-204.166h258.127V687.7h127.302V442.686H561.102zM321.065 646.852c-70.262 0-127.249-54.855-127.249-122.506s56.996-122.507 127.249-122.507c70.298 0 127.293 54.855 127.293 122.507s-56.995 122.506-127.293 122.506z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol